module.exports = __webpack_public_path__ + "img/wap-xhs.30983c9d.png";